<template>
  <div class="mx-auto">
    <div style="display: flex">
      <div
        :style="{
          width: '100%',
          borderRadius: '5px',
        }"
        class="primary"
      >
        <div class="d-flex justify-space-between ma-4">
          <v-text-field
            dense
            solo
            v-model="search"
            append-icon="mdi-magnify"
            :label="$tc('commons.search')"
            single-line
            hide-details
            class="search"
          />

          <v-col cols="auto" class="my-n4 pr-0">
            <v-row class="justify-start border ma-0">
              <!-- Botón de Refresh -->
              <v-col cols="auto pa-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="refreshItems"
                      class="btn-table ma-1"
                      small
                    >
                      <v-icon
                        :class="{ loader: loading4 }"
                        :loading="loading4"
                        :disabled="loading4"
                        id="icon-add"
                        class="mx-auto"
                        size="19"
                      >
                        fas fa-sync-alt
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $tc("commons.refresh") }}</span>
                </v-tooltip>
              </v-col>

              <!-- Botón de Configurar Columnas -->
              <v-col cols="auto pa-0">
                <div class="d-flex justify-center">
                  <v-dialog
                    v-model="btnConfigColumns.menu"
                    max-width="400px"
                    @keydown.esc="toggleColumnMenu"
                    offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="white"
                            dark
                            icon
                            @click="toggleColumnMenu"
                            v-bind="attrs"
                            v-on="on"
                            class="btn-table ma-1"
                            small
                          >
                            <v-icon size="20">{{
                              btnConfigColumns.icon
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ btnConfigColumns.tooltip }}</span>
                      </v-tooltip>
                    </template>
                    <v-card>
                      <v-text-field
                        v-model="columnFilter"
                        placeholder="Buscar columnas"
                        outlined
                        dense
                        hide-details
                        class="pa-2 pb-0 ma-0"
                      ></v-text-field>
                      <div
                        style="
                          min-width: 250px;
                          max-height: 250px;
                          overflow-y: scroll;
                          scrollbar-width: unset;
                        "
                        class="pa-2 pb-0 ma-0"
                        hide-details
                      >
                        <div
                          v-if="filteredColumns?.length === 0"
                          class="text-center px-2 pb-2"
                        >
                          <span
                            >No hay resultados que coincidan con la
                            búsqueda</span
                          >
                        </div>
                        <div v-else>
                          <div
                            v-for="column in filteredColumns"
                            :key="column.field"
                            hide-details
                          >
                            <v-checkbox
                              v-model="column.visible"
                              :label="column.text"
                              hide-details
                              class="my-auto mb-2"
                            ></v-checkbox>
                          </div>
                        </div>
                      </div>
                      <v-card-actions class="d-flex justify-space-between">
                        <v-btn class="bt-exit" @click="toggleColumnMenu">
                          <v-icon>fas fa-times</v-icon>
                        </v-btn>

                        <v-btn
                          color="bt-acept"
                          @click="
                            saveConfigColums();
                            toggleColumnMenu();
                          "
                        >
                          <v-icon>fas fa-save</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </v-col>

              <!-- Botón de Añadir -->
              <v-col cols="auto pa-0">
                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="white"
                        dark
                        icon
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          size="20"
                          class="mx-auto"
                          id="icon-add"
                          v-bind="attrs"
                          v-on="on"
                          @click="openAdd"
                          :disabled="!verifyExistingAction(asegurable)"
                        >
                          fas fa-plus
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("commons.add") }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </div>
        <v-divider class="mt-1 blue lighten-5" />
        <v-data-table
          :no-data-text="$tc('editRegistrations.notData')"
          class="elevation-3"
          :headers="visibleHeaders"
          :items="items"
          fixed-header
          style="min-width: 100%"
          :height="calculateMaxHeight"
          :search="search"
          :hide-default-footer="true"
          disable-pagination
          :loading-text="$tc('editRegistrations.loadingItems')"
          :loading="loader"
          v-sortable-columns="saveColumnOrder"
          :key="tableKey"
        >
          <template v-slot:header.actions="{ header }">
            <span class="d-flex justify-center">
              {{ header.text }}
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-space-around" style="width: 100px">
              <v-tooltip bottom v-if="showEdit">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <div class="ma-0">
                      <v-icon
                        id="icon-edit"
                        @click="openEdit(item)"
                        :disabled="!verifyExistingAction(asegurable)"
                      >
                        fas fa-pen
                      </v-icon>
                    </div>
                  </span>
                </template>
                <span>{{ $tc("editRegistrations.edit") }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!notShowDelete">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <div class="ma-0">
                      <v-icon
                        id="icon-delete"
                        @click="openDelete(item)"
                        :disabled="!verifyExistingAction(asegurable)"
                      >
                        fas fa-trash
                      </v-icon>
                    </div>
                  </span>
                </template>
                <span>{{ $tc("editRegistrations.delete") }}</span>
              </v-tooltip>
              <!-- btn view saldos en cuentas -->
              <v-tooltip bottom v-if="showAdd">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <div class="ma-0">
                      <v-icon
                        size="25"
                        class="icon mx-1"
                        @click="openAddInitialBalance(item)"
                      >
                        mdi-plus
                      </v-icon>
                    </div>
                  </span>
                </template>
                <span>Agregar movimiento</span>
              </v-tooltip>
              <v-tooltip bottom v-if="showSeeDetails">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <div>
                      <v-icon
                        size="25"
                        class="icon"
                        @click="openAccountMovements(item)"
                      >
                        mdi-swap-vertical-bold
                      </v-icon>
                    </div>
                  </span>
                </template>
                <span>Ver movimientos</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import Sortable from "sortablejs";

export default {
  props: {
    asegurable: {
      type: String,
      default: "",
    },
    headers: Array,
    items: Array,
    openEdit: Function,
    openDelete: Function,
    loader: Boolean,
    search: String,
    itemsPerPage: Number,
    action: {
      type: Boolean,
      default: false,
    },
    openAction: Function,
    saveConfigColums: Function,
    notShowDelete: Boolean,
    openAdd: Function,
    openAccountMovements: Function,
    openAddInitialBalance: Function,
    showSeeDetails: {
      type: Boolean,
      default: false,
    },
    showAdd: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tableKey: 0,
      showColumnMenu: false,
      columnFilter: "",
      btnConfigColumns: {
        menu: false,
        icon: "mdi-cog",
        tooltip: "Columnas",
      },
      loading4: false,
    };
  },
  computed: {
    calculateMaxHeight() {
      switch (true) {
        case this.items?.length >= 8:
          return "60vh";
      }
    },
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.headers.filter((column) => {
        return column.text.toLowerCase().includes(filterText);
      });
    },
    visibleHeaders() {
      return this.headers.filter((column) => column.visible);
    },
  },
  methods: {
    verifyExistingAction(accion) {
      if (typeof localStorage !== "undefined") {
        const asegurables =
          JSON.parse(localStorage.getItem("asegurables")) || [];
        return asegurables.includes(accion);
      }

      return false;
    },
    async refreshItems() {
      this.loading4 = true;
      try {
        await this.$emit("refreshItems");
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },
    toggleColumnMenu() {
      this.btnConfigColumns.menu = !this.btnConfigColumns.menu;
    },
    saveColumnOrder(newIndex, oldIndex) {
      const columnMoved = this.headers.splice(oldIndex, 1)[0];
      this.headers.splice(newIndex, 0, columnMoved);
      this.items.forEach((item) => {
        const movedData = item[columnMoved.value];
        delete item[columnMoved.value];
        item[columnMoved.value] = movedData;
      });
      this.tableKey++;
      this.$forceUpdate();
    },
  },
  directives: {
    sortableColumns: {
      inserted(el, binding) {
        const table = el.querySelector("table");
        const headerRow = table.querySelector("thead tr");
        const sortableHeaders = Array.from(headerRow.children);
        const options = {
          animation: 150,
          ghostClass: "sortable-ghost",
          onEnd: function (event) {
            const newIndex = event.newIndex;
            const oldIndex = event.oldIndex;
            binding.value(newIndex, oldIndex);
          },
        };
        Sortable.create(headerRow, options);
      },
    },
  },
};
</script>

<style scoped>
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
.icon {
  color: #43515c;
}
.btn-girado {
  transform: rotate(90deg);
}
.column-menu {
  border: 1px solid rgb(151, 151, 151);
  background-color: white;
  overflow-y: auto;
  position: relative;
  border-radius: 5px;
  overflow-x: hidden;
}
.search {
  max-width: 500px;
}
.search-columns {
  max-width: 230px;
}
#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
